import { type Writable } from "svelte/store";
export class Ok<A, E> {
  readonly error: undefined;
  constructor(readonly value: A) {}

  map<B>(fn: (a: A) => B): Ok<B, E> {
    return ok(fn(this.value));
  }

  mapErr<E2>(_: (a: E) => E2): Ok<A, E2> {
    return ok(this.value);
  }

  isOk(): this is Ok<A, E> {
    return true;
  }

  isErr(): this is Err<A, E> {
    return false;
  }

  isLoading(): this is Loading<A, E> {
    return false;
  }

  unwrapOr<B>(_: B): A | B {
    return this.value;
  }

  or<B>(res: Result<B, E>): Result<A | B, E> {
    return this;
  }

  optional(): A | undefined {
    return this.value;
  }
}

export class Err<A, E> {
  constructor(readonly error: E) {}

  get value(): undefined {
    return undefined;
  }
  map<B>(_: (v: A) => B): Err<B, E> {
    return err<B, E>(this.error);
  }
  mapErr<E2>(fn: (a: E) => E2): Err<A, E2> {
    return err<A, E2>(fn(this.error));
  }

  isOk(): this is Ok<A, E> {
    return false;
  }

  isErr(): this is Err<A, E> {
    return true;
  }

  isLoading(): this is Loading<A, E> {
    return false;
  }

  or<B>(res: Result<B, E>): Result<A | B, E> {
    return res;
  }
  unwrapOr<B>(def: B): A | B {
    return def;
  }
  optional(): A | undefined {
    return undefined;
  }
}

export class Loading<A, E> {
  constructor() {}

  isOk(): this is Ok<A, E> {
    return false;
  }

  isErr(): this is Err<A, E> {
    return false;
  }

  isLoading(): this is Loading<A, E> {
    return true;
  }

  unwrapOr<B>(def: B): A | B {
    return def;
  }
  optional(): A | undefined {
    return undefined;
  }
}

export type Result<A, E> = Ok<A, E> | Err<A, E>;
export type ApiCallVariant<A, E> = Ok<A, E> | Err<A, E> | Loading<A, E>;
export type ApiCall<A, E> = Writable<ApiCallVariant<A, E>>;

export function ok<a, e>(value: a): Ok<a, e> {
  return new Ok(value);
}

export function err<a, e>(error: e): Err<a, e> {
  return new Err(error);
}

export function loading<A, E>(): Loading<A, E> {
  return new Loading();
}
